import type { ShareProfileCandidateInfo } from './ShareProfileModal';
import { normalizeSkillsList } from '../../utils/userProfile';

type UserLike =
  | {
      firstName?: string;
      lastName?: string;
      fname?: string;
      lname?: string;
      jobTitle?: string;
      role_title?: string;
      profileImg?: string;
      resume?: string;
      resumeFileName?: string;
      hasResume?: boolean;
      skills?: unknown;
    }
  | null
  | undefined;

export function buildShareCandidateInfo(options: {
  user?: UserLike;
  jobTitle?: string;
  prompts?: unknown[];
  portfolio?: { overview?: string; projects?: unknown[] } | null;
  profileCompletePercent?: number | null;
}): ShareProfileCandidateInfo {
  const user = options.user;
  const displayName =
    [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() ||
    [user?.fname, user?.lname].filter(Boolean).join(' ').trim() ||
    undefined;

  const prompts = Array.isArray(options.prompts) ? options.prompts : [];
  const hasVideo = prompts.some((p) => {
    if (!p || typeof p !== 'object') return false;
    const row = p as Record<string, unknown>;
    return Boolean(row.fileUrl || row.file_url || row.has_video || row.hasVideo);
  });

  const portfolio = options.portfolio;
  const hasPortfolio = Boolean(
    portfolio?.overview?.trim?.() ||
      (Array.isArray(portfolio?.projects) && (portfolio?.projects?.length ?? 0) > 0)
  );

  return {
    displayName,
    jobTitle: options.jobTitle || user?.jobTitle || user?.role_title,
    profileImg: user?.profileImg,
    profileCompletePercent: options.profileCompletePercent ?? null,
    hasPortfolio,
    hasVideoResponses: hasVideo,
    hasResume: Boolean(user?.hasResume || user?.resume || user?.resumeFileName),
    hasSkills: normalizeSkillsList(user?.skills).length > 0,
    hasAvailability: true,
  };
}
